import { onMounted, computed, type Ref } from 'vue';
import { every } from 'lodash';
import { useUiStore, type UiState } from '@/stores';

export const useImageLoaded = (
  LCPImagesLoadedKey: keyof UiState['LCPImagesLoaded'],
  LCPImagesLoaded: Ref<{ [key: string]: boolean }>
) => {
  const uiStore = useUiStore();
  const allImagesLoaded = computed(() => every(LCPImagesLoaded.value, (e) => e === true));

  onMounted(() => {
    if (!uiStore.LCPImagesLoaded[LCPImagesLoadedKey]) {
      uiStore.loading = true;
    }
  });

  const onImageLoaded = (imageKey: string) => {
    if (!uiStore.LCPImagesLoaded[LCPImagesLoadedKey]) {
      LCPImagesLoaded.value[imageKey] = true;

      if (allImagesLoaded.value) {
        uiStore.LCPImagesLoaded[LCPImagesLoadedKey] = true;
        setTimeout(() => (uiStore.loading = false), 1300);
      }
    }
  };

  return { onImageLoaded };
};
